<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search_tips') || '样品款号/样品名称搜索......'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('batchChangeLocation')"
              v-if="allow('P')"
            >
              {{ $l('btn_change_storage') || '设置库位' }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('batchSampleListing')"
              v-if="allow('S')"
            >
              {{ $l('btn_sample_listing') || '样品上架' }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('export')"
              v-if="allow('E')"
            >
              <i class="el-icon-folder-opened mr-1"></i
              >{{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_sample_no') || '样品款号'">
              <el-input
                v-model.trim="form.sampleStyleNo"
                :placeholder="
                  $l('form_label_please_enter_the_sample_no') ||
                    '请输入样品款号'
                "
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_sample_name') || '样品名称'">
              <el-input
                v-model.trim="form.sampleName"
                :placeholder="
                  $l('form_label_please_enter_sample_name') || '请输入样品名称'
                "
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_stock_location_no') || '存放库位'"
            >
              <el-input
                v-model.trim="form.locationNo"
                :placeholder="
                  $l('form_label_please_enter_the_location') || '请输入存放库位'
                "
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_change_time') || '修改日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateBegin"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-row>
              <el-form-item
                :label="$l('form_label_stockNumberBegin') || '库存数量'"
              >
                <el-col :span="11">
                  <el-input-number
                    v-model="form.stockNumberBegin"
                    size="small"
                    class="stock-number"
                    :min="0"
                    :placeholder="
                      $l('form_placeholder_select_stock_number') ||
                        '选择库存数量'
                    "
                    controls-position="right"
                    style="width: 100%;"
                  >
                  </el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.stockNumberEnd"
                    size="small"
                    class="stock-number"
                    :min="0"
                    :placeholder="
                      $l('form_placeholder_select_stock_number') ||
                        '选择库存数量'
                    "
                    controls-position="right"
                    style="width: 100%;"
                  >
                  </el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {
        keyword: '',
        sampleStyleNo: '',
      }
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
